import { Interpolation } from "@emotion/core";
import { Colors } from "../../../../design-tokens/colors";
import { Device, DarkTheme } from "../../../../design-tokens/media-queries";
import { Border } from "../../../../design-tokens/borders";
import { grid } from "../../../../design-tokens/grid";
import { Keyframes } from "../../../../design-tokens/animation";

const card: Interpolation = {
  position: "relative",
  backgroundColor: Colors.LightGrey,
  padding: `${grid(3)} ${grid(2)}`,
  animation: `${Keyframes.FadeIn} 0.3s linear`,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBlack,
  },

  [Device.Desktop]: {
    padding: `${grid(3)} ${grid(4)} ${grid(4)} ${grid(5.5)}`,
    marginLeft: grid(5),
    borderRadius: Border.Radius,
  },

  [Device.Tablet]: {
    padding: `${grid(3)} ${grid(3)}`,
    borderRadius: Border.Radius,
  },
};

const styles = {
  card,
};

export default styles;
